<template>
  <div>
    <v-btn
      class="google-sign-in-button"
      color="white"
      light
      large
      :loading="isSigningIn"
      :disabled="isSigningIn || !authReady"
      @click="signIn"
    >
      <v-icon left color="#4285f4">mdi-google</v-icon>
      Continue with Google
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'GoogleSignInButton',
  data: () => ({
    isSigningIn: false,
  }),
  computed: {
    authReady() {
      return this.$store.getters.authReady;
    },
  },
  methods: {
    async signIn() {
      this.isSigningIn = true;

      try {
        await this.$store.dispatch('signInWithGoogle');
        this.$emit('signed-in');
      } catch (error) {
        // The store converts Firebase error codes into a user-facing message.
      } finally {
        this.isSigningIn = false;
      }
    },
  },
};
</script>

<style scoped>
.google-sign-in-button {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}
</style>
